// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-b197c6ea] .mandatory .v-label.v-label--active:after,\n.mandatory .v-label[data-v-b197c6ea]:after {\n  margin-left: 3px;\n}\n", ""]);
// Exports
module.exports = exports;
